<section class="saved-search has-box-shadow is-flex has-flex-align-center">
  <div *ngIf="parentComponent === SavedSearchLocationType.SAVED_SEARCHES"  class="content flex-one">
    <div>
      <div class="circle is-flex has-flex-align-center has-flex-content-center" [ngClass]="ListingCategory[savedSearch.listingCategory]">
        <img src="{{'/assets/icons/saved_search/SaveSearch@1x.svg' | staticp}}" alt="Save Icon"/>
      </div>
      <div (click)="onSavedSearchClick.emit(savedSearch)">
        <h3>{{ savedSearch.name }}</h3>
        <p class="multi-line-ellipsis" translate="my-remax.saved-searches.near" [translateParams]="{place: description}"></p>
      </div>
    </div>
    <hr/>
      <div class="group-items">
        <div class="notificationCheckBox">
          <label>
            <input type="checkbox" name="savedSearchNotification"  [(ngModel)]="savedSearch.notificationsEnabled" (ngModelChange)="modelChanged($event)">
            {{ enableNotificationText | translate }}
          </label>
        </div>
        <a class="delete" (click)="onDeleteClick($event)" *ngIf="enableDeleteSearch">
            <img height="20" width="20"
            src="{{'/assets/icons/saved_search/trash.svg'}}"/>
        </a>
      </div>
  </div>
  <div *ngIf="parentComponent === SavedSearchLocationType.SAVE_SEARCH" class="content flex-one save-search">
    <div class="circle is-flex has-flex-align-center has-flex-content-center" [ngClass]="ListingCategory[savedSearch.listingCategory]">
      <img src="{{'/assets/icons/saved_search/SaveSearch@1x.svg' | staticp}}" alt="Save Icon"/>
    </div>
    <div (click)="onSavedSearchClick.emit(savedSearch)">
      <h3>{{ savedSearch.name }}</h3>
      <p class="multi-line-ellipsis" translate="my-remax.saved-searches.near" [translateParams]="{place: description}"></p>
      <a class="delete" (click)="onDeleteClick($event)" *ngIf="enableDeleteSearch">X Delete</a>
    </div>
  </div>
</section>
